import dummyData from '../../../data/dummyData.json';
import { getCampaignData } from '../../../services/api/GoogleApi';
import { constructKpis } from './constructKpis';

const environment = process.env.REACT_APP_SERVER;


/* Fetch and setCampaign data */
export const fetchCampaignData = async (report, googleResponses, setGoogleResponses, clientId, managerAccountId, managerAccessToken, alertMessage, isLoading, setIsLoading) => {
    for await ( let campaign of report.campaigns ) { console.log('REPORT',report);
        if ( !campaign?.kpis ) {
            if ( environment === 'LOCAL' ) {    // Dummy data
                setGoogleResponses({...googleResponses, campaignData: [{
                    campaign: dummyData.getCampaignData.campaignData[0].campaign,
                    metrics: dummyData.getCampaignData.campaignData[0].metrics,
                    kpis: constructKpis(dummyData.getCampaignData.campaignData[0])
                }]})
                return
            }
    
            let loadingIds = isLoading.loadingCampaignIds;
            loadingIds.push(campaign.campaign.id)
            setIsLoading({loading: true, loadingCampaignIds: loadingIds});
            getCampaignData(clientId, managerAccountId, campaign.campaign.id, managerAccessToken, report?.dates)
            .then((response) => {
                const getCampaignData = response?.data?.data?.campaignData;
                const campaignData = googleResponses.campaignData;
                if ( getCampaignData[0] ) {
                    campaignData.push({
                        campaign: getCampaignData[0]?.campaign,
                        metrics: getCampaignData[0]?.metrics,
                        kpis: constructKpis(getCampaignData[0])
                    });
                    setGoogleResponses({...googleResponses, campaignData: campaignData})
                    let loadingIds = isLoading.loadingCampaignIds;
                    loadingIds = loadingIds.filter(item => item !== campaign.campaign.id);
                    setIsLoading({loading: false, loadingCampaignIds: loadingIds});

                }
                else {alertMessage(("Something went wrong while fetching campaign kpis"),'Error');}
            })
            .catch(error=>{
                console.error(error); 
                alertMessage(("Something went wrong while fetching campaign kpis"),'Error');
                return
            })
        }
    }
}